module.exports = __webpack_public_path__ + "files/535799f47920a91408b333d340e99212.png";